import {
  DISPLAY_LOADER,
  DISABLED_LOADER,
  CHECKING_DATA,
} from "../types/loader.types";

export const displayLoader = () => {
  return {
    type: DISPLAY_LOADER,
  };
};

export const disabledLoader = () => {
  return {
    type: DISABLED_LOADER,
  };
};

export const checkingData = () => {
  return {
    type: CHECKING_DATA,
  };
};
